export enum KnmSignatureInfoStatusesEnum {
  VALID = 'VALID',
  INVALID = 'INVALID',
  IN_PROCESS = 'IN_PROCESS',
}
